import axios from 'axios/index';
import { wrapActionModel } from '../../../utils/actionModelWrapper';

import content360 from './modules/content360Store';
import ra3d from './modules/ra3dStore';
import raDom from './modules/raDomStore';
import redirection from './modules/redirectionStore';
import story from './modules/storyStore';
import viewer3d from './modules/viewer3dStore';

axios.interceptors.response.use((response) => { // intercept the global error
    return response;
}, function (error) {
    if (error.response.status === 401) {
        window.location.href = '/login';
        return;
    }
    return Promise.reject(error);
});

export default {
    namespaced: true,
    modules: {
        content360,
        ra3d,
        raDom,
        redirection,
        story,
        viewer3d
    },
    state: {
        mode: '',
        newType: '',
        newAugmentationName: '',
        action: {},
        hasBeenEdit: false,
        experience: { name: '' },
        augmentation: { name: '' }
    },
    getters: {
        mode: (state) => {
            return state.mode;
        },
        action: (state) => {
            return state.action;
        },
        newType: (state) => {
            return state.newType;
        },
        currentActionType: (state) => {
            return state.action.action_type ? state.action.action_type : undefined;
        },
        experience: (state) => {
            return state.experience;
        },
        augmentation: (state) => {
            return state.augmentation;
        },
        hasBeenEdit: (state) => {
            return state.hasBeenEdit;
        },
        getDefaultData: (state) => (type) => {
            return type === 'redirection' ? state.redirection.defaultRedirection
                : type === 'story' ? state.story.defaultStory
                    : type === 'viewer3d' ? state.viewer3d.defaultViewer3d
                        : type === 'raDom' ? state.raDom.defaultRaDom
                            : type === 'ra3d' ? state.ra3d.defaultRa3d
                                : type === 'content360' ? state.content360.defaultContent360 : {};
        }
    },
    mutations: {
        SET_MODE_ACTION: (state, data) => {
            state.mode = data.mode;
            state.newType = data.newType;
        },
        SET_EXPERIENCE: (state, data) => {
            state.experience = data;
        },
        SET_AUGMENTATION: (state, data) => {
            state.augmentation = data;
        },
        SET_ACTION: (state, value) => {
            state.action = { ...value };
        },
        SET_ACTION_DATA: (state, data) => {
            let currentData = 'current' + data.type.charAt(0).toUpperCase() + data.type.slice(1);
            state[data.type][currentData] = { ...data.data };
        },
        UPDATE_ACTION_TYPE: (state, value) => {
            state.action.action_type = value.action_type;
            state.action.data = { ...value.data };
        },
        UPDATE_ACTION_DATA: (state, value) => {
            state.action.data = { ...value };
        },
        SET_AUGMENTATION_NAME: (state, data) => {
            state.newAugmentationName = data;
        },
        CLEAN_CURRENT_ACTION: (state) => {
            state.action = {};
        }
    },
    actions: {
        modeResetAction: (localStore) => {
            localStore.commit('SET_MODE_ACTION', {
                mode: '',
                newType: ''
            });
        },
        modeUpdateTypeAction: (localStore, data) => {
            localStore.commit('SET_MODE_ACTION', {
                mode: 'updateType',
                newType: data
            });
        },
        loadExperience: (localStore, token) => {
            return new Promise((resolve, reject) => {
                axios.get('/campaign/' + token).then((response) => {
                    localStore.commit('SET_EXPERIENCE', response.data);
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        loadAugmentation: (localStore, token) => {
            return new Promise((resolve, reject) => {
                axios.get('/campaign/' + localStore.state.experience.token + '/augmentations/' + token)
                    .then((response) => {
                        localStore.commit('SET_AUGMENTATION', response.data);
                        localStore.commit('SET_AUGMENTATION_NAME', response.data.name);
                        resolve();
                    }, (err) => {
                        reject(err);
                    });
            });
        },
        loadAction: (localStore) => {
            return new Promise((resolve, reject) => {
                axios.get('/action/' + localStore.state.augmentation.action).then((response) => {
                    let result = wrapActionModel(response.data);
                    localStore.commit('SET_ACTION', result);
                    localStore.commit('SET_ACTION_DATA', { type: result.action_type, data: result.data });
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        updateActionData: (localStore, data) => {
            return new Promise((resolve, reject) => {
                let value = { ...localStore.state.action };
                value.data = data;
                axios.put('/action/' + localStore.state.action._id, value).then((response) => {
                    if (response.data.success) {
                        localStore.commit('SET_ACTION', value);
                        localStore.commit('SET_ACTION_DATA', { type: value.action_type, data: value.data });
                        resolve();
                    } else {
                        reject(new Error(response.data.message));
                    }
                }, (err) => {
                    reject(err);
                });
            });
        },
        updateActionType: function (localStore) {
            return new Promise(function (resolve, reject) {
                let newData = { ...localStore.getters.getDefaultData(localStore.state.newType) };
                newData.action_type = localStore.state.newType;
                axios.put('/action/' + localStore.state.action._id, {
                    action_type: localStore.state.newType,
                    data: newData
                }).then(() => {
                    localStore.commit('UPDATE_ACTION_TYPE', { action_type: localStore.state.newType, data: newData });
                    localStore.commit('SET_ACTION_DATA', { type: localStore.state.newType, data: newData });
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        },
        tryRedirection: function (localStore) {
            return new Promise(function (resolve) {
                let obj1 = localStore.state.action.data;
                let currentData = 'current' + localStore.state.action.action_type.charAt(0).toUpperCase() +
                    localStore.state.action.action_type.slice(1);
                let obj2 = localStore.state[localStore.state.action.action_type][currentData];
                if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                    resolve(true);
                } else {
                    localStore.commit('SET_MODE_ACTION', {
                        mode: 'notSave',
                        newType: ''
                    });
                    resolve(false);
                }
            });
        },
        updateAugmentationName: function (localStore, data) {
            return new Promise(function (resolve, reject) {
                let value = { ...localStore.state.augmentation };
                value.name = localStore.state.newAugmentationName;
                axios.put('/campaign/' + data.experienceToken + '/augmentations/' + data.augmentationToken, value)
                    .then(() => {
                        localStore.commit('SET_AUGMENTATION', value);
                        localStore.commit('SET_AUGMENTATION_NAME', value.name);
                        resolve();
                    }, (err) => {
                        reject(err);
                    });
            });
        },
        updateAugmentationImages: function (localStore, data) {
            return new Promise(function (resolve, reject) {
                let value = { ...localStore.state.augmentation };
                value.iamges = data.images;
                axios.put('/campaign/' + data.experienceToken + '/augmentations/' + data.augmentationToken, value)
                    .then(() => {
                        localStore.commit('SET_AUGMENTATION', value);
                        resolve();
                    }, (err) => {
                        reject(err);
                    });
            });
        },
        cleanActions: function (localStore) {
            return new Promise(function (resolve) {
                localStore.commit('CLEAN_CURRENT_ACTION');
                localStore.commit('content360/CLEAN_CURRENT_DATA');
                localStore.commit('ra3d/CLEAN_CURRENT_DATA');
                localStore.commit('raDom/CLEAN_CURRENT_DATA');
                localStore.commit('redirection/CLEAN_CURRENT_DATA');
                localStore.commit('story/CLEAN_CURRENT_DATA');
                localStore.commit('viewer3d/CLEAN_CURRENT_DATA');
                resolve();
            });
        }
    }
};
